import React, { useEffect } from "react";
import { Breadcrumb, BreadcrumbItem, Col, Container, Row } from "reactstrap";
import Loading from "../components/Loading";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import ResponsiveEmbed from "react-responsive-embed";
import useScreenType from "react-screentype-hook";
import ReactGA from "react-ga4";
const file = require("../assets/V0 Privacy Policy_08292023.pdf") + "#toolbar=0";

export const PrivacyComponent = (props) => {
  const screenType = useScreenType();

  const loadData = async () => {};

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/privacy-policy/",
    });
    loadData();
    return () => {
      // Side-effect cleanup
    };
  }, []);

  return (
    <Container className="py-5">
      <h1 className="pb-5 text-align-center">Privacy Policy</h1>
      <ResponsiveEmbed
        ratio={screenType.isMobile ? "2:4" : "1:1"}
        src={file}
      ></ResponsiveEmbed>
    </Container>
  );
};

export default withAuthenticationRequired(PrivacyComponent, {
  onRedirecting: () => <Loading />,
});
